import { LOADING_STATE } from "types/general";
import { IState } from "./types";

export const REVIEWS_SLICE_NAME = "reviews";

export const initialState: IState = {
  loadingState: LOADING_STATE.idle,
};
